module.exports = __webpack_public_path__ + "img/security.88657134.svg";